var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.data !== null || _vm.id !== null,
        transition: false,
        "max-width": 800,
        persistent: false,
      },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.data !== null || _vm.id !== null
        ? _c("FormInfoCategory", {
            attrs: {
              title: _vm.data.id
                ? "Редактировать категорию"
                : "Создать категорию",
              id: _vm.id,
              data: _vm.data,
              language: _vm.language,
              "info-categories": _vm.infoCategories,
              loading: _vm.loading,
              disabled: _vm.disabled,
            },
            on: {
              cancel: function ($event) {
                return _vm.$emit("close")
              },
              "language-update": _vm.updateLocaleHandler,
              submit: _vm.submit,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }